import { Gender } from '@uplift/types';
import uniqBy from 'lodash/uniqBy';

const getGenderLabel = (name: string) => {
  switch (name) {
    case 'Cisgender man':
      return 'Male';
    case 'Cisgender woman':
      return 'Female';
    case 'Gender nonbinary':
      return 'Non-binary';
    default:
      return name;
  }
};

export const transformOnboardingGenderLabels = (genders: Gender[]) => {
  return uniqBy(genders.map(gender => ({ ...gender, name: getGenderLabel(gender.name) })), 'name');
};
